var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsync2, useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../../../api/API";
import { FreeCell, TableContext } from "../../../../misc/scroller/Table";
import { useContext, useRef, useState } from "react";
import { Button, Checkbox, CircularProgress, FormControlLabel, Grid, InputAdornment, TextField } from "@mui/material";
import { Popover } from "../../../../misc/Popover";
import { Loader } from "../../../../misc/Loader";
import { css } from "@emotion/css";
import { blue } from "@mui/material/colors";
import { useSyncedRef } from "../../../../misc/SyncedRef";
import { useAlternative } from "../alternative/Alternative";
import { useColumnIndex } from "../../../../misc/scroller/GroupRowUtil";
import { doorHm, doorOther, doorWd } from "./Common";
import { useProjectId } from "../../shopdrawing/ProjectName";
import { IndexCounter } from "../../shopdrawing/pricing/IndexCounter";
import { PlainHeader } from "./PlainHeader";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const groupTitle = css({ fontSize: "0.9rem", fontWeight: 500 });
export function BeforeGroup2(props) { if (props.name.endsWith("-riders") || props.name.startsWith("door-riders/")) {
    return /*#__PURE__*/ _jsx(Riders, {});
} const rows = priceRowToValues(props.rows); return /*#__PURE__*/ _jsx(BeforeGroup, { name: props.name, rows: rows }); }
export function priceRowToValues(rows) { let qprices = []; rows.forEach(r => { if (r.kind === "quote-price") {
    qprices.push(r.value);
} }); return qprices; }
function Riders() { const counter = new IndexCounter(); const startIndex = useColumnIndex(markupColumnName); return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(FreeCell, { index: counter.incrBy(startIndex), colSpan: startIndex, children: /*#__PURE__*/ _jsx("div", { className: groupTitle, children: "Riders" }) }) }); }
export function BeforeGroup(props) {
    if (props.name.startsWith("hardware/")) {
        return /*#__PURE__*/ _jsx(PlainHeader, { name: props.name });
    }
    let name = props.name;
    if (props.name === "hardware-before") {
        name = "hardware";
    }
    if (name.startsWith("door-prep")) {
        name = "door-prep";
    }
    switch (name) {
        case "hardware":
        case "frame":
        case "frame-prep":
        case "door-prep":
        case "frame-anchor":
        case "door-hm":
        case "door-wd":
        case "door-other": // case "div-10":
        case 'div-10/corner-guard':
        case 'div-10/locker':
        case 'div-10/mailbox':
        case 'div-10/wr-accessory':
        case 'div-10/wr-partition': return /*#__PURE__*/ _jsx(BeforeGroupInner, { name: name, rows: props.rows });
        default: return null;
    }
}
export function getSectionName(name) { switch (name) {
    case "door-totals": return "Page";
    case "frame-totals": return "Page";
    case "frame": return "Frames";
    case "frame-prep": return "Frame Preps";
    case "door-prep/hm":
    case "door-prep/wd":
    case "door-prep/other":
    case "door-prep": return "Door Preps";
    case "door-riders/wd":
    case "door-riders/hm": return "Door Rider";
    case "frame-anchor": return "Frame Anchors";
    case "door": return "Doors";
    case doorWd: return "Doors - Wood";
    case doorHm: return "Doors - HM";
    case doorOther: return "Doors - Other";
    case "hardware": return "Hardware";
    case "hardware-riders": return "Hardware Rider";
    case "div-10": return "Div 10";
    case 'div-10/corner-guard': return "Corner Guard";
    case 'div-10/locker': return "Locker";
    case 'div-10/mailbox': return "Mailbox";
    case 'div-10/wr-accessory': return "W/R Accessory";
    case 'div-10/wr-partition': return "W/R Partition";
    case 'div-10/corner-guard-riders':
    case 'div-10/locker-riders':
    case 'div-10/mailbox-riders':
    case 'div-10/wr-accessory-riders':
    case 'div-10/wr-partition-riders': return "Rider";
    default:
        if (name.startsWith("hardware/"))
            return "Hardware";
        if (name.startsWith("door-"))
            return "Doors";
        console.warn("missing section name for", name);
        return "";
} }
export const markupColumnName = "Markup";
function BeforeGroupInner(props) {
    const project = useProjectId();
    const alt = useAlternative();
    const data = useAsync2(args => api.pricing.getProjectMarkups(args), { project: project, alternative: alt }, [project, alt]);
    const tblCtx = useContext(TableContext);
    const reload = useSyncedRef(tblCtx.reload);
    const reloadData = useRef(data.reload);
    const update = useAsyncAction((args) => __awaiter(this, void 0, void 0, function* () { yield api.pricing.updateProjectMarkups(args); reloadData.current(); reload.current(false); setEditEl(null); return null; }), []);
    const [editEl, setEditEl] = useState(null);
    const [value, setValue] = useState("");
    const counter = new IndexCounter();
    const [updateExisting, setUpdateExisting] = useState(true);
    const key = props.name;
    const alternative = useAlternative();
    const showMarkup = props.name !== "frame-anchor" && !props.name.includes("prep");
    const startIndex = useColumnIndex(markupColumnName);
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(FreeCell, { index: counter.incrBy(startIndex), colSpan: startIndex, children: /*#__PURE__*/ _jsx("div", { className: groupTitle, children: getSectionName(props.name) }) }), showMarkup && /*#__PURE__*/ _jsxs(FreeCell, { index: counter.incrBy(3), colSpan: 3, children: [/*#__PURE__*/ _jsx("div", { style: { marginTop: -4, marginBottom: -4, marginLeft: -6, marginRight: -6, paddingLeft: 6, paddingRight: 6, paddingTop: 4, paddingBottom: 4 }, className: clickable, onClick: e => {
                            setValue(data.result[key] || "");
                            setEditEl(e.currentTarget);
                        }, children: /*#__PURE__*/ _jsxs(Grid, { container: true, justifyContent: "space-between", style: { width: "100%" }, children: [/*#__PURE__*/ _jsx(Grid, { item: true, className: groupTitle, children: "Default Markup" }), data.loading ? /*#__PURE__*/ _jsx(Grid, { item: true, children: /*#__PURE__*/ _jsx(CircularProgress, { size: "inherit" }) }) : !!data.error ? /*#__PURE__*/ _jsx(Grid, { item: true, children: data.error }) : /*#__PURE__*/ _jsxs(Grid, { item: true, children: [data.result && data.result[key], "%"] })] }) }), !!editEl && /*#__PURE__*/ _jsx(Popover, { open: true, anchorEl: editEl, onClose: () => setEditEl(null), children: /*#__PURE__*/ _jsx("div", { style: { padding: 8 }, children: /*#__PURE__*/ _jsxs("form", { onSubmit: e => { e.preventDefault(); update.callback({ project: project, alternative: alternative, [key]: tryParse(value), updateExisting: updateExisting }); }, children: [/*#__PURE__*/ _jsx("div", { className: groupTitle, children: "Default Markup" }), /*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsx(TextField, { variant: "outlined", placeholder: "5", value: value, onChange: e => setValue(e.target.value), InputProps: { inputProps: { style: { textAlign: "right" } }, endAdornment: /*#__PURE__*/ _jsx(InputAdornment, { position: "end", children: "%" }) } }), /*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsx(FormControlLabel, { control: /*#__PURE__*/ _jsx(Checkbox, { checked: updateExisting, onChange: (e, checked) => setUpdateExisting(checked) }), label: "Update existing markups" }), /*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsxs(Grid, { container: true, justifyContent: "flex-end", children: [/*#__PURE__*/ _jsx(Grid, { item: true, children: /*#__PURE__*/ _jsx(Loader, Object.assign({}, update)) }), /*#__PURE__*/ _jsx(Grid, { item: true, children: /*#__PURE__*/ _jsx(Button, { onClick: () => setEditEl(null), children: "Cancel" }) }), /*#__PURE__*/ _jsx(Grid, { item: true, children: /*#__PURE__*/ _jsx(Button, { type: "submit", children: "Update" }) })] })] }) }) })] }), /*#__PURE__*/ _jsx(FreeCell, { index: counter.next(), grow: true })] });
}
function tryParse(input) { const v = parseInt(input); if (isNaN(v))
    return input; return v; }
const clickable = css({ border: "1px solid transparent", cursor: "pointer", "&:hover": { borderColor: blue["600"] } });
